import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { isMobileState } from '../../recoil/selectors';
import { LiftWearCamiLanderMobile } from './LiftWearCamiLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { ProductComparison } from '../components/ProductComparison';
import { LanderTopHero } from '../components/LanderTopHero';
import { allProductsState } from '../../recoil/atoms';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { useLanderControls } from '../LanderContext';
import { useProductAssets } from '../../hooks/useProductAssets';

export const LiftWearCamiLander: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const isMobile = useRecoilValue(isMobileState);
  const product = allProducts[ProductHandle.LiftWearCami];
  const productAssets = useProductAssets(product);
  const wistiaVideoId = productAssets.videos[0]?.wistiaId;
  const padding = { padding: '56.25% 0 0 0' };
  const { scrollToProductSection } = useLanderControls();

  if (isMobile) {
    return <LiftWearCamiLanderMobile />;
  }

  return (
    <>
      <CardBody>
        <LanderTopHero
          maxHeroContainerHeight={'1066px'}
          heroImage={'desktop-liftwear-cami-lander-top-hero-1.jpg'}
          title={'LiftWear Cami'}
          subTitle={
            <>
              Meet the world&apos;s <br />
              smartest Cami.
            </>
          }
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Adjustable
                <br /> straps
              </>
            }
            labelColor={'black'}
            titleStyles={{ marginTop: -4 }}
            inlineStyles={{
              desktop: {
                left: `88.5%`,
                top: `21%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Wire-free
                <br />
                lift
              </>
            }
            labelColor={'black'}
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              desktop: {
                left: `88.5%`,
                top: `49%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted <br />
                Smoothing
              </>
            }
            inlineStyles={{
              desktop: {
                right: `12%`,
                top: `62%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-lwc-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'A bonded cradle and molded removable cups lift your chest for support and comfort.',
            },
            {
              imgName: 'feature-lwc-desktop-2.jpg',
              title: 'Targeted smoothing',
              description: 'Targeted X-shaped panel on the interior hugs your midsection for extra waist shaping.',
            },
            {
              imgName: 'feature-lwc-desktop-3.jpg',
              title: 'Adjustable straps',
              description: 'Adjust the lenght of your straps, or cross them in the back from extra support.',
            },
          ]}
        />
        <ProductComparison
          onCtaClick={scrollToProductSection}
          competitorImage="liftwear-competitor.jpg"
          honeyloveImage="liftwear-honeylove.jpg"
          honeyloveText="LiftWear"
          competitorText="Competitor"
          title={
            <>
              The perfect layering <br /> piece for a smoother fit.
            </>
          }
        />
        {wistiaVideoId && (
          <div style={{ padding: '50px 60px', paddingTop: 40, boxSizing: 'border-box' }}>
            <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
          </div>
        )}
        <ShopAllColors product={allProducts[ProductHandle.LiftWearCami]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default LiftWearCamiLander;
